import { render, staticRenderFns } from "./UserAccessPreview.vue?vue&type=template&id=9e4b60fc&scoped=true"
import script from "./UserAccessPreview.vue?vue&type=script&lang=js"
export * from "./UserAccessPreview.vue?vue&type=script&lang=js"
import style0 from "./UserAccessPreview.vue?vue&type=style&index=0&id=9e4b60fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4b60fc",
  null
  
)

export default component.exports